import { Component, Input, OnInit } from '@angular/core';
import { FormatUtilities } from '../utilities/format-utilities';
import { DailyActivityReport } from '../data/daily-activity-report';
import { DataService } from '../data/data.service';

@Component({
  selector: 'app-class-eeu-report',
  templateUrl: './class-eeu-report.component.html',
  styleUrls: ['./class-eeu-report.component.scss']
})
export class ClassEeuReportComponent implements OnInit {

  monthNames = FormatUtilities.monthNames;

  @Input() classID: number;
  @Input() organizationID: number;

  eeuReport: DailyActivityReport[];
  schoolStart: Date;

  constructor(protected dataService: DataService) { }

  ngOnInit() {
    this.getEEUReport();
  }

  getEEUReport(): void {
    this.schoolStart = new Date();
    this.schoolStart.setDate(this.schoolStart.getDate() - 20);
    this.schoolStart.setHours(0, 0, 0, 0);  

    this.updateEEUReport();
  }

  updateEEUReport(): void {
    this.dataService.getDailyActivityReport(this.classID, this.schoolStart, 21).subscribe(r => {
      this.eeuReport = r.sort((a,b) => {
        if ( a.Name.toLocaleLowerCase() < b.Name.toLocaleLowerCase() ){
          return -1;
        }
        if ( a.Name.toLocaleLowerCase() > b.Name.toLocaleLowerCase() ){
          return 1;
        }
        return 0;
      });
    });
  }

  getShortDate(date: Date): string {
    var month = date.getUTCMonth();
    var day = date.getUTCDate();
    return `${this.monthNames[month]} ${day}`;
  }

  getDisplayDate(offset?: number): string {
    if (!offset) offset = 0;

    var offsetDate;
    if (!this.schoolStart.getTime){
      offsetDate = new Date(this.schoolStart);
    }
    else offsetDate = new Date(this.schoolStart.getTime());

    offsetDate.setDate(offsetDate.getDate() + offset);
    return this.getShortDate(offsetDate);
  }

  getRunningActivityCount(student: DailyActivityReport, days: number) {
    var countedDays = student.Days.slice(0, days);
    var total = countedDays.reduce((sum, next) => sum + next.Activities, 0);
    return total;
  }

  isOnTrack(student: DailyActivityReport, days: number, target: number) {
    var count = this.getRunningActivityCount(student, days);
    return count >= target;
  }

}
